import { Admin, Resource } from 'react-admin';
import { AuthGate } from '@/components/auth';

/* ----------------------------- LAYOUTS ----------------------------- */
import { DefaultLayout } from '@/components/layouts';

/* ----------------------------- MUI ----------------------------- */
import DraftsIcon from '@mui/icons-material/Drafts';
import UserIcon from '@mui/icons-material/Group';
import { TurnReferencesEnum } from '@/types/turn-enums';

/* ----------------------------- PAGES ----------------------------- */
import { Login, NotFound } from '@/pages';

/* ----------------------------- PAGES PROPS ----------------------------- */
import { AdverseList } from '@/pages/AdverseAction/actions';
import { AdverseView } from '@/pages/AdverseAction';
import { CandidateEdit, CandidateList, NationalRecordEdit } from '@/pages/Candidate/actions';
import { CandidateView } from '@/pages/Candidate';

/* ----------------------------- REDUX ----------------------------- */
import { Provider } from 'react-redux';
import { store } from '@/store/index';

/* ----------------------------- SERVICES ----------------------------- */
import turnProvider from '@/services/api';

/* ----------------------------- SETTINGS ----------------------------- */
import { BrowserRouter } from 'react-router-dom';

/* ----------------------------- STYLES ----------------------------- */
import '@/styles/app.css';
import { DARK_THEME_OPTIONS, LIGHT_THEME_OPTIONS } from '@/styles/theme';

const App = ({ auth }) => {
  return (
    <Provider store={store}>
      <AuthGate auth={auth}>
        <BrowserRouter>
          <Admin
            catchAll={NotFound}
            darkTheme={DARK_THEME_OPTIONS}
            dataProvider={turnProvider}
            defaultTheme="light"
            layout={DefaultLayout}
            loginPage={Login}
            theme={LIGHT_THEME_OPTIONS}
            title="Turn Admin"
          >
            <Resource
              name={TurnReferencesEnum.Candidates}
              icon={UserIcon}
              list={CandidateList}
              edit={CandidateEdit}
              show={CandidateView}
            />
            <Resource name={TurnReferencesEnum.Adverse} icon={DraftsIcon} list={AdverseList} show={AdverseView} />
            <Resource name={TurnReferencesEnum.CmCriminal} />
            <Resource name={TurnReferencesEnum.NationalRecord} icon={DraftsIcon} edit={NationalRecordEdit} />
            <Resource name={TurnReferencesEnum.AdminPartners} />
            <Resource name={TurnReferencesEnum.AdminStates} />
            <Resource name={TurnReferencesEnum.AdminServiceProviders} />
            <Resource name={TurnReferencesEnum.AdminMVRProviders} />
          </Admin>
        </BrowserRouter>
      </AuthGate>
    </Provider>
  );
};

export default App;
